import filterCards from '../data/filterCards';
import filterButtons from '../data/filterButtons';

const getFilterCards = (category = false) => {

    return filterCards.map((card, i) => {
        const setSelected = (category === false || (category !== false && category === filterCards[i].category)) ? true : false;
        return Object.assign({}, card, {
            selected: setSelected,
        });
    });
};

const getFilterButtons = (category = false) => {

    return filterButtons.map((button, i) => {
        const setSelected = (category !== false && category === filterButtons[i].category) ? true : false;
        return Object.assign({}, button, {
            selected: setSelected,
        });
    });
};

const initialState = {
    cards: getFilterCards(filterButtons[0].category),
    buttons: getFilterButtons(filterButtons[0].category),
    category: false,
};

const influenceData = (state = initialState, action) => {

    switch (action.type) {
        case "INFLUENCE_UPDATE":
            if (action.category === state.category) action.category = false;
            return Object.assign({}, state, {
                cards: getFilterCards(action.category),
                buttons: getFilterButtons(action.category),
                category: action.category,
            });
        default:
            return state;
    }
};

export default influenceData;



// WEBPACK FOOTER //
// ./src/reducers/influenceData.js